import { ApolloClient } from '@apollo/client';

import {
  ActivityOutcomeGroup,
  ActivityOutcomes,
} from 'approot/activity-builder/components/teaching-notes/key-activity-information/activity-outcomes.constants';
import {
  ACTIVITIES_CONTENT_STATUS_DRAFT,
  ActivitiesContentType,
  LANGUAGE_CODE_EN_AU,
  LESSON_ACTIVITIES,
} from 'global/constants';

export function modifyOutcomesInCache({
  client,
  id,
  outcomes,
  contentType,
}: {
  client: ApolloClient<any>;
  id: number;
  outcomes: ActivityOutcomeGroup[];
  contentType: ActivitiesContentType;
}) {
  client.cache.modify({
    id: client.cache.identify({
      id,
      language: LANGUAGE_CODE_EN_AU,
      version: ACTIVITIES_CONTENT_STATUS_DRAFT,
      __typename:
        contentType === LESSON_ACTIVITIES
          ? 'LessonActivities'
          : 'AssessmentActivities',
    }),
    fields: {
      outcomes: (existing: ActivityOutcomes | null) => {
        return {
          ...existing,
          __typename: 'ActivityOutcomes',
          outcomes,
        };
      },
    },
  });
}
